import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pw);
      toast.success("Welcome back");
      nav("/app");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1570616969692-54d6ba3d0397?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
          alt="School" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1E36]/80 to-[#0B1E36]/20" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="font-serif text-3xl leading-tight max-w-md">"The leaders who make time to feel are the ones their teams stay with."</div>
        </div>
      </div>
      <div className="flex flex-col justify-center px-8 lg:px-16 py-16">
        <Link to="/" className="flex items-center gap-2 mb-12" data-testid="logo-link">
          <div className="h-10 w-10 rounded-xl bg-[#0B1E36] grid place-items-center">
            <Sparkles className="h-5 w-5 text-[#C9A961]" />
          </div>
          <div>
            <div className="font-serif text-lg text-[#0B1E36]">Future Counts OS™</div>
            <div className="text-[10px] tracking-widest text-slate-500 uppercase">by the Collective</div>
          </div>
        </Link>
        <h1 className="font-serif text-4xl text-[#0B1E36] mb-2">Welcome back.</h1>
        <p className="text-slate-600 mb-10">Sign in to continue your leadership practice.</p>
        <form onSubmit={onSubmit} className="max-w-md space-y-5">
          <div>
            <label className="text-sm font-semibold text-[#0B1E36]">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-[#EC4899]/40 focus:border-[#EC4899] outline-none" />
          </div>
          <div>
            <label className="text-sm font-semibold text-[#0B1E36]">Password</label>
            <input data-testid="login-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
              className="mt-1.5 w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-[#EC4899]/40 focus:border-[#EC4899] outline-none" />
          </div>
          <button data-testid="login-submit" disabled={loading} type="submit"
            className="w-full bg-[#0B1E36] text-white py-3.5 rounded-full font-semibold btn-lift hover:bg-[#132a4a] disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-sm text-slate-600 text-center">
            New here? <Link to="/signup" data-testid="to-signup" className="text-[#EC4899] font-semibold hover:underline">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
